import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

const enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right'
}

@Component({
  selector: 'my-account-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent {
  @Input() text: string;

  @Input() iconClass: string;

  @Input() internalUrl: string;

  @Input() externalUrl: string;

  @Input() iconPosition = IconPosition.LEFT;

  @Output() clickEvent = new EventEmitter();

  constructor(private readonly router: Router) {}

  goToUrl(): void {
    if (this.internalUrl) {
      this.router.navigate([this.internalUrl]);
    } else if (this.externalUrl) {
      window.open(this.externalUrl, '_self');
    }
  }

  onClickEvent(): void {
    this.clickEvent.emit();
  }
}
